export const RESERVATION_TYPES = {
    SHUTTLE_TYPES: {
        SCHEDULED: 'scheduled',
        ON_DEMAND: 'on-demand',
        RIDE_SHARE: 'taxi',
        CURBSIDE_VALET: 'curbside-valet',
        PUBLIC_TRANSIT: 'public-transit',
    },
    POST_PURCHASE_ERRORS_ENUM: {
        NO_ID: 'noReservationId',
        NOT_FOUND: 'notFound',
        NO_ACCESS_KEY: 'noAccessKey',
        ACCESS_DENIED: 'accessDenied',
        GENERIC_ERROR: 'error',
    },
    PAYMENT_STATUSES: {
        REFUND: 'refund',
        SUCCESS: 'success',
        REFUND_PENDING: 'refund pending',
    },
    RESERVATION_STATUSES: {
        CANCELLED: 'cancelled',
    },
    PARKING_PASS_TYPES_ENUM: {
        OPERATOR_SCAN: 'operator_scan',
        PRINTOUT: 'printout',
        LICENSE_PLATE: 'license_plate',
        SCAN_IN_OUT: 'scan_in_out',
        SCAN_IN_TICKET_OUT: 'scan_in_ticket_out',
        PULL_TICKET_SCAN_OUT: 'pull_ticket_scan_out',
        PULL_TICKET_CALL_BUTTON: 'pull_ticket_call_button',
        PULL_TICKET_SEE_ATTENDANT: 'pull_ticket_see_attendant',
        SELF_PARK_SEE_ATTENDANT: 'self_park_see_attendant',
        VALET: 'valet',
        VENDGATE: 'vendgate',
        VENDGATE_WITH_SCAN: 'vendgate_with_scan',
        HANG: 'hang',
        ACCESS_CARD: 'access_card',
        STICKER: 'sticker',
        LPR: 'lpr',
        GATED_LPR_WITH_SCAN: 'gated_lpr_with_scan',
    },
    /* eslint-disable camelcase */
    IN_OUT_MAPPING: {
        yes: 'Unlimited In/Out',
        yes_fee: 'Unlimited In/Out with Fee',
        yes_limited: 'Limited In/Out',
        yes_limited_fee: 'Limited In/Out with Fee',
        no: null,
    },
    /* eslint-enable camelcase */
    RESERVATION_TYPES: {
        AIRPORT: 'airport',
        EVENT_PACKAGE: 'event_package',
        MONTHLY: 'monthly',
        TRANSIENT: 'transient',
        EVENT: 'event',
    },
};
